var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSubmarine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 599,
    height: 378,
    viewBox: "0 0 599 378",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M521.342 129.481V119.721L546.111 91.7497H577.717V131.405L562.986 160.349L521.342 129.481Z",
    fill: "#8B969C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M518.467 192.67H484.085V204.245H518.467V192.67Z",
    fill: "#32292C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M439.882 58.8493H433.796V65.4403H439.882V58.8493Z",
    fill: "#8B969C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M433.589 17.8494H433.676C433.881 17.8494 434.083 17.8899 434.272 17.9684C434.461 18.047 434.633 18.1621 434.777 18.3072C434.922 18.4524 435.037 18.6247 435.115 18.8143C435.193 19.004 435.233 19.2072 435.233 19.4125V77.1686H432.032V19.4125C432.032 18.9979 432.197 18.6004 432.488 18.3072C432.78 18.0141 433.176 17.8494 433.589 17.8494Z",
    fill: "#8B969C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M438.924 0.000106721C438.71 -0.00573638 438.497 0.0315061 438.298 0.109633C438.099 0.187761 437.917 0.305188 437.764 0.454976C437.611 0.604764 437.489 0.783873 437.406 0.981721C437.323 1.17957 437.28 1.39214 437.28 1.60687V77.4965H440.546V1.60687C440.546 1.39402 440.504 1.18328 440.422 0.986898C440.341 0.790518 440.221 0.612409 440.07 0.462918C439.919 0.313427 439.74 0.195532 439.543 0.116083C439.346 0.0366326 439.136 -0.00278927 438.924 0.000106721Z",
    fill: "#8B969C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M412.424 35.3162H413.687C415.55 35.3162 417.336 36.0589 418.653 37.3811C419.97 38.7032 420.71 40.4965 420.71 42.3663V72.9713H406.556V41.2732C406.55 40.4948 406.698 39.723 406.99 39.0019C407.282 38.2808 407.713 37.6248 408.258 37.0713C408.803 36.5179 409.452 36.0779 410.167 35.7767C410.882 35.4755 411.649 35.319 412.424 35.3162Z",
    fill: "#AAB2B8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M408.777 63.5056C410.639 63.5056 412.426 62.7628 413.742 61.4407C415.059 60.1185 415.799 58.3253 415.799 56.4555V35.6878C415.116 35.4719 414.404 35.3614 413.687 35.3599H412.424C411.651 35.3599 410.885 35.5128 410.17 35.81C409.456 36.1072 408.806 36.5428 408.259 37.0919C407.712 37.641 407.279 38.2929 406.983 39.0103C406.687 39.7277 406.534 40.4967 406.534 41.2732V63.5056H408.777Z",
    fill: "#C6D0D6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M442.724 71.5504H430.813C429.989 71.5504 429.322 72.2208 429.322 73.0478V73.9113C429.322 74.7383 429.989 75.4088 430.813 75.4088H442.724C443.548 75.4088 444.215 74.7383 444.215 73.9113V73.0478C444.215 72.2208 443.548 71.5504 442.724 71.5504Z",
    fill: "#8B969C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M421.983 71.5504H407.035C405.989 71.5504 405.141 72.4019 405.141 73.4522V74.5781C405.141 75.6285 405.989 76.48 407.035 76.48H421.983C423.03 76.48 423.878 75.6285 423.878 74.5781V73.4522C423.878 72.4019 423.03 71.5504 421.983 71.5504Z",
    fill: "#8B969C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M445.587 73.8348H392.653L387.743 75.8023L382.68 88.8532H453.306L451.531 75.5618L445.587 73.8348Z",
    fill: "#493C3F"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M409.615 73.8348H391.183L386.676 75.8023L380.296 88.8532H398.728L405.108 75.8023L409.615 73.8348Z",
    fill: "#655157"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M424.085 81.8359H366.436L358.532 99.3026H429.855V83.8361L424.085 81.8359Z",
    fill: "#BDC4CA"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M366.436 81.8359L363.05 89.3232C365.979 89.6074 369.093 89.7713 372.305 89.7713C387.264 89.7713 399.839 86.4048 403.54 81.8359H366.436Z",
    fill: "#DBE3E8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M460.895 81.8359H397.628L388.962 99.3026H467.22V87.7274L460.895 81.8359Z",
    fill: "#8B969C"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M516.703 209.918H506.774L506.883 213.776H516.812L516.703 209.918Z",
    fill: "#8B969C"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M524.228 129.481V119.721L548.996 91.7497H580.602V131.405L565.871 160.349L524.228 129.481Z",
    fill: "#BEC6CC"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M524.445 119.48C530.327 120.4 536.272 120.857 542.224 120.846C557.205 120.846 570.782 118.059 580.602 113.556V91.6951H549.029L524.445 119.48Z",
    fill: "#D7DFE2"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M521.777 127.601H484.945V151.08H521.777V127.601Z",
    fill: "#8B969C"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M510.138 132.105H484.945V155.583H510.138V132.105Z",
    fill: "#6A7A80"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M382.768 235.692L255.473 232.588L255.223 235.692L258.598 244.01H386.154L382.768 235.692Z",
    fill: "#BDC4CA"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M348.865 113.763L359.534 97.4882H277.008L264.923 117.622L255.234 235.43H367.711L350.672 220.761L348.865 113.763Z",
    fill: "#BDC4CA"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M385.424 235.408H370.411L353.415 220.761L351.597 113.763L362.267 97.4882H279.741L267.656 117.622L257.966 235.408L261.254 243.157H388.81L385.424 235.408Z",
    fill: "#8B969C"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M272.12 243.157H388.81L385.424 235.408H370.41L353.415 220.761L351.597 113.763L362.267 97.4882H279.741L267.656 117.622L259.371 218.356L272.12 243.157Z",
    fill: "#6A7A80"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M292.5 231.462H269.866L265.489 244.01H288.124L292.5 231.462Z",
    fill: "#BDC4CA"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M358.053 231.462H273.709L269.332 244.01H353.676L358.053 231.462Z",
    fill: "#98A0A6"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M269.278 240.447H258.707V244.01H269.278V240.447Z",
    fill: "#BDC4CA"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M345.032 263.411C363.191 263.411 377.911 250.262 377.911 234.041C377.911 217.821 363.191 204.672 345.032 204.672C326.873 204.672 312.152 217.821 312.152 234.041C312.152 250.262 326.873 263.411 345.032 263.411Z",
    fill: "#2F2628"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M345.032 261.52C362.024 261.52 375.799 249.218 375.799 234.041C375.799 218.865 362.024 206.562 345.032 206.562C328.039 206.562 314.264 218.865 314.264 234.041C314.264 249.218 328.039 261.52 345.032 261.52Z",
    fill: "#567483"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M318.129 243.474C321.298 252.984 331.194 259.925 342.811 259.925C346.495 259.934 350.145 259.221 353.557 257.826C350.399 248.317 340.546 241.43 328.875 241.43C325.196 241.411 321.547 242.105 318.129 243.474Z",
    fill: "#7490A1"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M356.202 256.558C358.014 256.819 359.863 256.507 361.49 255.665C363.118 254.822 364.443 253.492 365.282 251.858C365.908 250.749 366.311 249.527 366.469 248.262C364.656 247.997 362.806 248.307 361.177 249.147C359.547 249.988 358.219 251.317 357.378 252.951C356.757 254.065 356.357 255.29 356.202 256.558Z",
    fill: "#7490A1"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M341.308 207C340.154 207.186 339.009 207.43 337.879 207.732C348.788 211.186 356.714 221.887 356.714 234.457C356.714 247.027 348.755 257.717 337.846 261.171C338.975 261.478 340.12 261.722 341.276 261.903C346.442 259.432 350.805 255.542 353.86 250.683C356.915 245.825 358.536 240.197 358.536 234.451C358.536 228.706 356.915 223.078 353.86 218.22C350.805 213.361 346.442 209.471 341.276 207H341.308Z",
    fill: "#2F2628"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M313.851 240.578C314.053 241.545 314.308 242.501 314.613 243.442C319.828 245.956 331.477 247.704 345.032 247.704C358.587 247.704 370.225 245.956 375.44 243.442C375.75 242.503 376.005 241.547 376.202 240.578C373.143 243.649 360.078 245.956 345.032 245.956C329.986 245.956 316.91 243.649 313.851 240.578Z",
    fill: "#2F2628"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M365.576 225.461H288.494C290.973 229.468 294.428 232.776 298.533 235.071C302.638 237.365 307.257 238.572 311.956 238.578H365.576V225.461Z",
    fill: "#2F2628"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M331.172 105.817H277.313V108.386H331.172V105.817Z",
    fill: "#2F2628"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M332.62 105.577H280.917V112.977H332.62V105.577Z",
    fill: "#2F2628"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M345.13 111.851H277.662L258.075 139.745L252.708 205.207L268.157 227.603H350.683L345.13 111.851Z",
    fill: "#655157"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M389.659 111.851H322.179L308.156 139.745L315.821 205.207L335.734 227.603H418.271L389.659 111.851Z",
    fill: "#493C3F"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M346.741 138.018L341.875 115.283H325.315L313.459 138.018H346.741Z",
    fill: "#2F2628"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M344.716 136.641L340.448 116.66H325.892L315.473 136.641H344.716Z",
    fill: "#3A505B"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M339.828 134.739L336.736 120.267H326.197L318.652 134.739H339.828Z",
    fill: "#526D7E"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M325.914 136.641H344.716L340.448 116.66H325.892L322.876 122.442L325.914 136.641Z",
    fill: "#3A505B"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M361.189 205.633H321.45L338.543 224.182H365.152L361.189 205.633Z",
    fill: "#2F2628"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M358.597 206.978H324.607L339.229 222.838H361.983L358.597 206.978Z",
    fill: "#3A505B"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M311.727 141.319L311.629 141.516L319.011 202.332H360.481L347.449 141.319H311.727Z",
    fill: "#2F2628"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M313.186 143.144L313.088 143.33L320.034 200.507H359.022L346.763 143.144H313.186Z",
    fill: "#3A505B"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M315.832 145.396L315.745 145.571L322.321 198.266H356.79L345.522 145.396H315.832Z",
    fill: "#526D7E"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M339.196 200.507H359.022L346.763 143.144H326.937L339.196 200.507Z",
    fill: "#3A505B"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M512.718 135.57H456.855V199.316H514.547L522.637 161.737L512.718 135.57Z",
    fill: "#493C3F"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M532.054 135.57H492.25L502.397 199.316H543.518L543.301 161.737L532.054 135.57Z",
    fill: "#32292C"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M282.702 97.4882H277.422L275.974 101.423H281.265L282.702 97.4882Z",
    fill: "#BDC4CA"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M276.801 106.484H339.632L334.09 94.7009H282.256L276.801 106.484Z",
    fill: "#DBE3E8"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M306.698 106.484H339.741L334.188 94.7009H312.141L306.698 106.484Z",
    fill: "#8B969C"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M309.213 106.484H326.502L318.554 97.4882H314.068L309.213 106.484Z",
    fill: "#6A7A80"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M361.047 231.462H338.412L342.462 244.01H365.097L361.047 231.462Z",
    fill: "#A4ADB3"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M364.879 231.462H342.256L346.306 243.157H368.94L364.879 231.462Z",
    fill: "#6A7A80"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M354.373 240.447H343.802V244.01H354.373V240.447Z",
    fill: "#A4ADB3"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M482.364 235.32H351.891L348.331 244.01H474.319L482.364 235.32Z",
    fill: "#A4ADB3"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M482.364 235.32H354.373L350.813 244.01H474.319L482.364 235.32Z",
    fill: "#89949C"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M317.117 97.4882H314.068V101.423H319.12L317.117 97.4882Z",
    fill: "#A4ADB3"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M484.869 117.633L472.479 97.4882H315.19L329.409 117.633L351.815 235.539H479.283L494.656 220.859L484.869 117.633Z",
    fill: "#A4ADB3"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M487.59 117.633L475.201 97.4882H317.912L332.13 117.633L354.537 235.539H482.005L497.378 220.859L487.59 117.633Z",
    fill: "#BEC6CC"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M463.41 169.301C463.41 142.598 458.271 117.851 449.507 97.4882H427.264C432.49 127.109 423.072 163.628 399.262 195.086C387.181 211.275 371.908 224.793 354.395 234.796L354.537 235.539H451.739C459.109 216.301 463.41 193.61 463.41 169.301Z",
    fill: "#C6D0D6"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M487.59 117.633L475.201 97.4882H317.912L332.13 117.633H487.59Z",
    fill: "#DBE3E8"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M517.313 127.601H501.439L512.326 213.777H526.578L517.313 127.601Z",
    fill: "#8B969C"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M555.833 133.252H579.666L580.602 131.405H555.833V133.252Z",
    fill: "#89949C"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M559.599 127.601H503.834L514.722 213.777H561.417L569.496 162.972L559.599 127.601Z",
    fill: "#BDC4CA"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M509.724 174.23H567.71L569.496 162.972L564.183 144.008H505.914L509.724 174.23Z",
    fill: "#C6D0D6"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M569.485 163.081L569.496 162.972L559.599 127.601H503.834L508.32 163.081H569.485Z",
    fill: "#DBE3E8"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M449.572 212.607L408.015 215.547L410.421 241.43L473.992 239.824L449.572 212.607Z",
    fill: "#89949C"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M471.259 165.508H470.65C470.561 165.52 470.47 165.512 470.384 165.486C470.298 165.46 470.218 165.416 470.151 165.356C470.083 165.297 470.029 165.223 469.992 165.141C469.955 165.059 469.936 164.97 469.936 164.879C469.936 164.789 469.955 164.7 469.992 164.618C470.029 164.535 470.083 164.462 470.151 164.403C470.218 164.343 470.298 164.299 470.384 164.273C470.47 164.247 470.561 164.239 470.65 164.251H471.14L467.982 130.902H467.394C467.313 130.904 467.231 130.889 467.155 130.858C467.079 130.827 467.01 130.781 466.952 130.723C466.894 130.665 466.849 130.596 466.818 130.519C466.787 130.443 466.772 130.362 466.774 130.279C466.772 130.197 466.787 130.114 466.818 130.038C466.849 129.961 466.894 129.891 466.952 129.832C467.01 129.773 467.078 129.726 467.154 129.694C467.23 129.662 467.312 129.645 467.394 129.645H467.863L466.676 116.835V116.682L454.831 97.4882H453.35L465.413 117.097L472.12 187.751H472.718C472.886 187.751 473.046 187.818 473.165 187.937C473.283 188.056 473.35 188.217 473.35 188.385C473.35 188.553 473.283 188.715 473.165 188.833C473.046 188.952 472.886 189.019 472.718 189.019H472.239L475.331 221.57L468.93 235.539H470.312L476.616 221.788L471.259 165.508Z",
    fill: "#6A7A80"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M374.831 189.019C374.663 189.019 374.502 188.952 374.384 188.833C374.266 188.715 374.199 188.553 374.199 188.385C374.199 188.217 374.266 188.056 374.384 187.937C374.502 187.818 374.663 187.751 374.831 187.751H375.037L361.548 116.769L348.004 97.4882H346.469L360.35 117.163L382.844 235.539H384.117L375.277 189.019H374.831Z",
    fill: "#6A7A80"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M374.83 187.751C374.663 187.751 374.502 187.818 374.384 187.937C374.266 188.056 374.199 188.217 374.199 188.385C374.199 188.553 374.266 188.715 374.384 188.834C374.502 188.952 374.663 189.019 374.83 189.019H472.707C472.875 189.019 473.036 188.952 473.154 188.834C473.272 188.715 473.339 188.553 473.339 188.385C473.339 188.217 473.272 188.056 473.154 187.937C473.036 187.818 472.875 187.751 472.707 187.751H374.83Z",
    fill: "#6A7A80"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M365.043 133.351C364.954 133.339 364.863 133.346 364.777 133.373C364.691 133.399 364.611 133.443 364.544 133.502C364.476 133.562 364.422 133.635 364.385 133.718C364.348 133.8 364.329 133.889 364.329 133.979C364.329 134.069 364.348 134.159 364.385 134.241C364.422 134.323 364.476 134.396 364.544 134.456C364.611 134.515 364.691 134.56 364.777 134.586C364.863 134.612 364.954 134.62 365.043 134.608H467.569C467.658 134.62 467.748 134.612 467.834 134.586C467.921 134.56 468 134.515 468.068 134.456C468.135 134.396 468.189 134.323 468.227 134.241C468.264 134.159 468.283 134.069 468.283 133.979C468.283 133.889 468.264 133.8 468.227 133.718C468.189 133.635 468.135 133.562 468.068 133.502C468 133.443 467.921 133.399 467.834 133.373C467.748 133.346 467.658 133.339 467.569 133.351H365.043Z",
    fill: "#6A7A80"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M467.394 129.645C467.312 129.645 467.23 129.662 467.154 129.694C467.078 129.726 467.009 129.773 466.952 129.832C466.894 129.891 466.848 129.961 466.818 130.038C466.787 130.114 466.772 130.197 466.774 130.279C466.772 130.362 466.787 130.443 466.818 130.52C466.849 130.596 466.894 130.665 466.952 130.723C467.01 130.781 467.079 130.827 467.155 130.858C467.231 130.889 467.312 130.904 467.394 130.902H488.842L488.723 129.645H467.394Z",
    fill: "#6A7A80"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M470.65 164.251C470.561 164.239 470.47 164.247 470.384 164.273C470.298 164.299 470.218 164.343 470.151 164.403C470.083 164.462 470.029 164.535 469.992 164.618C469.955 164.7 469.936 164.789 469.936 164.879C469.936 164.97 469.955 165.059 469.992 165.141C470.029 165.223 470.083 165.297 470.151 165.356C470.218 165.416 470.298 165.46 470.384 165.486C470.47 165.512 470.561 165.52 470.65 165.508H492.13L492.011 164.251H470.65Z",
    fill: "#6A7A80"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M305.152 141.483H260.601L255.539 203.152H312.381L305.152 141.483Z",
    fill: "#2F2628"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M304.684 142.926H263.802L259.164 201.698H311.314L304.684 142.926Z",
    fill: "#6D9EAB"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M305.685 138.215H262.441L279.099 113.938H318.391L305.685 138.215Z",
    fill: "#2F2628"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M305.108 137.329H265.642L280.84 115.163H316.703L305.108 137.329Z",
    fill: "#5E8292"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M294.264 130.039L312.239 115.163H298.772L286.077 130.039H294.264Z",
    fill: "#6D9EAB"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M276.322 133.679L294.297 115.163H280.84L268.135 133.679H276.322Z",
    fill: "#6D9EAB"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M270.617 225.516H330.182L313.056 206.868H257.476L270.617 225.516Z",
    fill: "#2F2628"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M273.285 224.619H328.472L312.599 207.339H261.113L273.285 224.619Z",
    fill: "#3A505B"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M275.952 223.177H325.75L311.423 208.53H264.978L275.952 223.177Z",
    fill: "#5D7988"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M407.863 215.394L444.052 252.689H474.482V250.12L448.211 210.563H407.863V215.394Z",
    fill: "#D7DFE2"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M407.863 215.394L444.052 252.689H474.482V250.12L446.502 249.049L407.863 210.563V215.394Z",
    fill: "#A4ADB3"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M269.779 185.806L259.033 201.698H311.314L309.441 185.806H269.779Z",
    fill: "#5E8292"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M310.584 195.239L304.683 142.926H272.697L277.792 195.239H310.584Z",
    fill: "#5E8292"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M302.277 148.183H265.957L262.691 183.073C271.903 180.002 280.612 175.582 288.538 169.957C293.943 166.223 298.952 161.941 303.486 157.179L302.277 148.183Z",
    fill: "#8BB7C0"
  }))), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M565.958 185.237L564.957 180.657L531.968 184.516L542.202 213.777H561.418L565.958 185.237Z",
    fill: "#89949C"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M533.166 183.871L559.437 209.175H596.084L598 206.388L573.024 177.018H531.892L533.166 183.871Z",
    fill: "#CFD6DB"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M572.6 177.072C564.347 182.778 559.034 191.653 559.034 201.622C559.037 204.211 559.403 206.787 560.123 209.273H596.105L598.022 206.486L573.024 177.072H572.6Z",
    fill: "#DBE3E8"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M559.437 209.175H596.084L598 206.388H559.677L559.437 209.175Z",
    fill: "#A4ADB3"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M531.892 177.018V184.734L559.437 209.175L560.874 206.388L531.892 177.018Z",
    fill: "#A4ADB3"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M280.829 135.941H268.614L281.395 117.305H311.553C308.61 122.928 304.192 127.636 298.777 130.92C293.362 134.205 287.156 135.941 280.829 135.941Z",
    fill: "#8BB7C0"
  }))), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M539.579 163.3L535.659 153.222H534.026L537.935 163.3H539.579Z",
    fill: "#89949C"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M566.643 152.796H507.024L507.166 153.944H566.97L566.643 152.796Z",
    fill: "#89949C"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M538.425 163.3H569.443L569.497 162.972L569.268 162.152H538.425V163.3Z",
    fill: "#89949C"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M585.752 191.992H567.2L568.376 193.042H586.655L585.752 191.992Z",
    fill: "#6A7A80"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M569.29 91.7497H567.363V132.269H569.29V91.7497Z",
    fill: "#89949C"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M456.137 86.7654H427.003C425.806 86.7654 424.836 87.7393 424.836 88.9406V90.8643C424.836 92.0656 425.806 93.0395 427.003 93.0395H456.137C457.334 93.0395 458.304 92.0656 458.304 90.8643V88.9406C458.304 87.7393 457.334 86.7654 456.137 86.7654Z",
    fill: "#6A7A80"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M415.516 86.7654H405.87C405.143 86.7654 404.553 87.3576 404.553 88.088V91.7169C404.553 92.4473 405.143 93.0395 405.87 93.0395H415.516C416.244 93.0395 416.834 92.4473 416.834 91.7169V88.088C416.834 87.3576 416.244 86.7654 415.516 86.7654Z",
    fill: "#6A7A80"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M410.508 37.9941C410.166 37.9883 409.825 38.051 409.507 38.1786C409.189 38.3062 408.9 38.4961 408.655 38.7372C408.411 38.9784 408.217 39.2659 408.085 39.5831C407.952 39.9002 407.884 40.2407 407.884 40.5846V56.0292C407.884 56.7163 408.156 57.3752 408.64 57.861C409.124 58.3468 409.78 58.6197 410.465 58.6197H410.606C411.291 58.6197 411.949 58.3472 412.434 57.8617C412.92 57.3762 413.194 56.7173 413.197 56.0292V40.7267C413.192 40.0093 412.908 39.3224 412.405 38.8121C411.903 38.3018 411.223 38.0083 410.508 37.9941Z",
    fill: "#3A505B"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M433.687 17.8494H433.589C433.178 17.8523 432.785 18.0183 432.495 18.3111C432.206 18.6039 432.043 18.9998 432.043 19.4125V57.4611C433.181 57.2856 434.271 56.8762 435.244 56.2588V19.4125C435.244 19.2072 435.204 19.004 435.126 18.8143C435.047 18.6247 434.933 18.4524 434.788 18.3072C434.644 18.1621 434.472 18.047 434.283 17.9684C434.094 17.8899 433.892 17.8494 433.687 17.8494Z",
    fill: "#C6D0D6"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M438.924 0.000106721C438.71 -0.00573638 438.497 0.0315061 438.298 0.109634C438.099 0.187761 437.917 0.305188 437.764 0.454976C437.611 0.604764 437.489 0.783873 437.406 0.981721C437.323 1.17957 437.28 1.39214 437.28 1.60687V54.652C438.498 53.5263 439.593 52.2731 440.546 50.9138V1.60687C440.546 1.39402 440.504 1.18328 440.422 0.986898C440.341 0.790518 440.221 0.61241 440.07 0.462918C439.919 0.313427 439.74 0.195533 439.543 0.116083C439.346 0.0366326 439.136 -0.00278928 438.924 0.000106721Z",
    fill: "#C6D0D6"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M407.863 215.394L444.052 252.689H474.482V250.12L448.211 210.563H407.863V215.394Z",
    fill: "#D7DFE2"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M407.863 215.394L444.052 252.689H474.482V250.12L446.502 249.049L407.863 210.563V215.394Z",
    fill: "#A4ADB3"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M445.718 248.262C444.019 248.59 442.386 248.961 440.851 249.355L444.052 252.634H474.482V250.065L446.502 248.972L445.718 248.262Z",
    fill: "#89949C"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M417.258 146.784H411.695L413.622 159.649H419.174L417.258 146.784Z",
    fill: "#6A7A80"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M428.352 146.784H422.8L424.727 159.649H430.279L428.352 146.784Z",
    fill: "#6A7A80"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M253.165 198.496C248.451 199.097 245.903 202.114 247.166 207.459C248.429 212.804 252.011 217.132 256.41 217.58C260.808 218.028 264.553 210.716 263.301 205.371C262.792 203.15 261.462 201.206 259.581 199.93C257.7 198.654 255.408 198.142 253.165 198.496Z",
    fill: "#493C3F"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M259.273 209.317C258.293 204.89 254.918 200.879 251.793 200.354C248.669 199.829 246.894 202.977 247.874 207.404C248.854 211.831 252.229 215.831 255.354 216.356C258.478 216.881 260.253 213.733 259.273 209.317Z",
    fill: "#2F2628"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M252.36 201.447C249.66 200.999 248.157 203.71 248.995 207.502C249.834 211.295 252.708 214.738 255.419 215.154C258.13 215.569 259.621 212.902 258.783 209.098C257.945 205.295 255.06 201.906 252.36 201.447Z",
    fill: "#6D9EAB"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M250.857 203.13C249.855 203.742 249.42 205.316 249.855 207.262C250.295 209.337 251.526 211.158 253.285 212.334C254.287 211.733 254.733 210.148 254.297 208.213C253.849 206.135 252.616 204.313 250.857 203.13Z",
    fill: "#8BB7C0"
  }))), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M308.255 198.496C303.54 199.097 300.993 202.114 302.256 207.459C303.519 212.804 307.101 217.132 311.499 217.58C315.897 218.028 319.643 210.716 318.391 205.371C317.881 203.15 316.552 201.206 314.671 199.93C312.79 198.654 310.497 198.142 308.255 198.496Z",
    fill: "#493C3F"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M314.362 209.317C313.382 204.89 310.007 200.879 306.883 200.354C303.758 199.829 301.983 202.977 302.963 207.404C303.943 211.831 307.318 215.831 310.443 216.356C313.568 216.881 315.342 213.733 314.362 209.317Z",
    fill: "#2F2628"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M307.449 201.447C304.749 200.999 303.246 203.71 304.085 207.502C304.923 211.295 307.797 214.738 310.508 215.154C313.219 215.569 314.711 212.902 313.872 209.098C313.034 205.295 310.149 201.906 307.449 201.447Z",
    fill: "#6D9EAB"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M308.93 207.819C308.516 205.98 307.537 204.316 306.131 203.065C304.858 203.546 304.259 205.251 304.76 207.546C305.169 209.385 306.149 211.046 307.558 212.29C308.81 211.82 309.43 210.071 308.93 207.819Z",
    fill: "#8BB7C0"
  }))), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M268.135 139.067H262.016V140.838H268.135V139.067Z",
    fill: "#DBE3E8"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M277.149 139.067H271.031V140.838H277.149V139.067Z",
    fill: "#DBE3E8"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M286.153 139.067H280.035V140.838H286.153V139.067Z",
    fill: "#DBE3E8"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M295.157 139.067H289.038V140.838H295.157V139.067Z",
    fill: "#DBE3E8"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M304.161 139.067H298.042V140.838H304.161V139.067Z",
    fill: "#DBE3E8"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M273.883 224.248H297.465L288.897 215.493H267.318L273.883 224.248Z",
    fill: "#8BB7C0"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M303.018 224.248H313.687L303.497 215.493H294.831L303.018 224.248Z",
    fill: "#8BB7C0"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.69
  }, _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M474.482 250.12L446.502 249.027L407.885 210.563L410.204 235.834L354.417 234.796L332.131 117.633L317.912 97.4882L312.142 94.7009H282.256L280.96 97.4882H277.008L264.923 117.622L263.769 131.635L258.075 139.745L253.285 198.485H253.198C248.484 199.086 245.947 202.103 247.199 207.448C248.451 212.793 252.044 217.121 256.442 217.569H256.736L255.266 235.419V235.681L258.641 243.999H314.167C318.739 255.312 330.857 263.4 345.108 263.4C359.36 263.4 371.467 255.312 376.039 243.999H435.702L444.129 252.678H474.559V250.109L474.482 250.12Z",
    fill: "#405050"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M470.301 235.539L450.77 212.388L470.639 244.01H474.319L482.016 235.703L470.301 235.539Z",
    fill: "#405050"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M503.834 127.601H501.439H489.909L496.05 204.245H511.118L511.836 209.918H506.774L506.883 213.777H512.326H514.722L504.346 127.601H503.834Z",
    fill: "#405050"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M560.874 206.388L531.892 177.018V184.734L542.202 213.776H561.418L562.148 209.175H596.084L598 206.388L597.902 206.267L560.874 206.388Z",
    fill: "#405050"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M303.736 136.236H268.156L281.864 116.256H314.188L303.736 136.236Z",
    fill: "#E7FFFD"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M252.36 201.447C249.66 200.999 248.157 203.71 248.995 207.502C249.834 211.295 252.708 214.738 255.419 215.154C258.13 215.569 259.621 212.902 258.783 209.098C257.945 205.295 255.06 201.906 252.36 201.447Z",
    fill: "#6D9EAB"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M253.056 202.365C250.715 201.972 249.409 204.322 250.138 207.612C250.868 210.902 253.35 213.886 255.702 214.279C258.054 214.673 259.349 212.323 258.62 209.033C257.89 205.743 255.397 202.759 253.056 202.365Z",
    fill: "#FFF7C6"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M307.449 201.447C304.749 200.999 303.246 203.71 304.085 207.502C304.923 211.295 307.797 214.738 310.508 215.154C313.219 215.569 314.711 212.902 313.872 209.098C313.034 205.295 310.149 201.906 307.449 201.447Z",
    fill: "#6D9EAB"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M304.129 142.959H262.517L257.781 200.551H310.868L304.129 142.959ZM266.567 174.996L304.673 163.836L308.625 198.496H260.34L266.567 174.996Z",
    fill: "#E7FFFD"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M304.771 142.019H261.799L256.921 201.491H311.739L304.771 142.019ZM264.009 143.735H303.127L309.463 199.37H259.567L264.009 143.735Z",
    fill: "#E7FFFD"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M308.222 201.95C305.827 201.545 304.498 203.95 305.239 207.317C305.979 210.683 308.505 213.733 310.933 214.137C313.361 214.542 314.667 212.137 313.916 208.77C313.165 205.404 310.617 202.354 308.222 201.95Z",
    fill: "#FFF7C6"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.61
  }, _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M279.185 117.578L265.642 137.329H305.108L309.213 129.481L279.185 117.578Z",
    fill: "#E7FFFD"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M306.281 203.857L149.276 268.627C141.777 271.721 135.186 276.844 130.299 283.319C102.818 319.724 126.144 372.752 171.643 375.969C189.432 377.227 206.552 368.945 216.608 354.217L312.933 213.137L306.281 203.857Z",
    fill: "url(#paint0_linear_243_921)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M252.212 202.879L91.0419 256.449C83.3437 259.008 76.4088 263.655 71.0781 269.77C41.1059 304.153 60.6453 358.69 105.805 365.098C123.462 367.604 141.122 360.546 152.189 346.561L258.195 212.604L252.212 202.879Z",
    fill: "url(#paint1_linear_243_921)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }, _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M497.149 106.112C498.58 106.112 499.74 104.948 499.74 103.511C499.74 102.074 498.58 100.909 497.149 100.909C495.718 100.909 494.558 102.074 494.558 103.511C494.558 104.948 495.718 106.112 497.149 106.112Z",
    fill: "#D9F2FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }, _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M513.491 62.9482C513.487 62.4338 513.331 61.9322 513.044 61.5063C512.757 61.0803 512.351 60.7488 511.877 60.5535C511.403 60.3582 510.883 60.3077 510.38 60.4083C509.878 60.509 509.416 60.7562 509.053 61.1192C508.69 61.4821 508.442 61.9446 508.34 62.4485C508.237 62.9525 508.285 63.4756 508.478 63.9522C508.671 64.4288 508.999 64.8378 509.422 65.1278C509.845 65.4178 510.344 65.5759 510.856 65.5824C511.203 65.5868 511.546 65.5217 511.867 65.391C512.188 65.2603 512.48 65.0666 512.725 64.8213C512.971 64.5759 513.165 64.2839 513.296 63.9622C513.428 63.6406 513.494 63.2958 513.491 62.9482Z",
    fill: "#D9F2FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }, _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M506.785 18.6692C506.787 18.1521 506.636 17.6459 506.351 17.2149C506.067 16.7838 505.661 16.4473 505.186 16.2479C504.711 16.0485 504.187 15.9952 503.682 16.0948C503.176 16.1943 502.712 16.4423 502.347 16.8072C501.982 17.1721 501.733 17.6375 501.631 18.1446C501.53 18.6516 501.581 19.1774 501.778 19.6554C501.974 20.1334 502.308 20.5421 502.736 20.8296C503.164 21.1171 503.668 21.2706 504.183 21.2706C504.524 21.2721 504.862 21.2058 505.178 21.0757C505.493 20.9457 505.78 20.7543 506.022 20.5126C506.264 20.2708 506.456 19.9836 506.586 19.6672C506.717 19.3509 506.785 19.0117 506.785 18.6692Z",
    fill: "#D9F2FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }, _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M521.003 16.811C523.126 16.811 524.847 15.0835 524.847 12.9526C524.847 10.8217 523.126 9.09418 521.003 9.09418C518.881 9.09418 517.16 10.8217 517.16 12.9526C517.16 15.0835 518.881 16.811 521.003 16.811Z",
    fill: "#D9F2FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }, _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M507.155 90.4818C508.586 90.4818 509.746 89.3171 509.746 87.8804C509.746 86.4436 508.586 85.2789 507.155 85.2789C505.724 85.2789 504.563 86.4436 504.563 87.8804C504.563 89.3171 505.724 90.4818 507.155 90.4818Z",
    fill: "#D9F2FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }, _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M508.265 101.281C508.276 100.762 508.133 100.251 507.853 99.8139C507.573 99.377 507.17 99.0336 506.695 98.8278C506.22 98.622 505.694 98.563 505.186 98.6585C504.677 98.7539 504.208 98.9994 503.84 99.3636C503.471 99.7277 503.218 100.194 503.115 100.703C503.011 101.212 503.061 101.74 503.258 102.221C503.455 102.701 503.79 103.112 504.22 103.4C504.65 103.688 505.157 103.841 505.674 103.839C506.353 103.836 507.004 103.567 507.488 103.089C507.972 102.611 508.251 101.962 508.265 101.281Z",
    fill: "#D9F2FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }, _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M513.731 35.8299C513.731 34.7334 513.407 33.6615 512.8 32.75C512.193 31.8384 511.33 31.1281 510.321 30.709C509.311 30.2899 508.201 30.1808 507.13 30.3955C506.059 30.6102 505.075 31.1391 504.304 31.9152C503.532 32.6913 503.007 33.6798 502.796 34.7555C502.584 35.8312 502.695 36.9458 503.114 37.9582C503.534 38.9706 504.243 39.8354 505.152 40.443C506.061 41.0506 507.129 41.3738 508.222 41.3716C509.684 41.3687 511.085 40.7836 512.118 39.7446C513.151 38.7057 513.731 37.2978 513.731 35.8299Z",
    fill: "#D9F2FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }, _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M522.996 76.2067C522.996 75.4436 522.77 74.6976 522.348 74.0631C521.926 73.4286 521.326 72.934 520.623 72.642C519.921 72.35 519.148 72.2736 518.403 72.4224C517.657 72.5713 516.972 72.9388 516.435 73.4784C515.898 74.018 515.531 74.7055 515.383 75.454C515.235 76.2024 515.311 76.9782 515.602 77.6833C515.893 78.3883 516.385 78.9909 517.017 79.4149C517.649 79.8389 518.392 80.0651 519.153 80.0651C520.172 80.0651 521.149 79.6586 521.87 78.935C522.591 78.2114 522.996 77.23 522.996 76.2067Z",
    fill: "#D9F2FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }, _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M517.672 49.9191C519.794 49.9191 521.515 48.1917 521.515 46.0607C521.515 43.9298 519.794 42.2023 517.672 42.2023C515.549 42.2023 513.829 43.9298 513.829 46.0607C513.829 48.1917 515.549 49.9191 517.672 49.9191Z",
    fill: "#D9F2FF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_243_921",
    x1: 283.505,
    y1: 179.329,
    x2: 191.134,
    y2: 296.553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_243_921",
    x1: 231.217,
    y1: 176.811,
    x2: 130.832,
    y2: 287.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7C6"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmarine);
export default __webpack_public_path__ + "static/media/submarine.2592b7286279bb258e398f6980d15f37.svg";
export { ForwardRef as ReactComponent };